import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";

const SEARCH_PLACES_FIELDS = "place_id,formatted_address,name";

const PLACE_DETAILS_FIELDS = "address_components,formatted_address,place_id";

export interface GoogleAddressComponent {
  long_name: string;
  short_name: string;
  types: string[];
}

export interface GooglePlaceCandidate {
  place_id?: string;
  formatted_address?: string;
  address_components?: GoogleAddressComponent[];
  name?: string;
}

export interface FindPlaceResponse {
  candidates: GooglePlaceCandidate[];
  status: string;
}

export interface PlaceDetailsResponse {
  result?: GooglePlaceCandidate;
  status: string;
}

@Injectable()
export class ToolkitBackend {
  private readonly http = inject(HttpClient);

  searchPlaces(query: string): Observable<FindPlaceResponse> {
    return this.http.get<FindPlaceResponse>(
      `${environment.snoots.toolkit.endpoint}/places`,
      {
        params: {
          input: query,
          inputtype: "textquery",
          language: "it",
          fields: SEARCH_PLACES_FIELDS
        }
      }
    );
  }

  getPlaceDetails(placeId: string): Observable<PlaceDetailsResponse> {
    return this.http.get<PlaceDetailsResponse>(
      `${environment.snoots.toolkit.endpoint}/places/${placeId}`,
      {
        params: {
          language: "it",
          fields: PLACE_DETAILS_FIELDS
        }
      }
    );
  }
}
